import { render } from "./FamiliaDetalle.vue?vue&type=template&id=7dae7be3&ts=true"
import script from "./FamiliaDetalle.vue?vue&type=script&lang=ts"
export * from "./FamiliaDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__